export class StringUtility {
  static isNullOrEmptyString(str: string) {
    return str === undefined || str === null || str === '';
  }

  static formatFein(str: string) {
    return str.substr(0, 2) + '-' + str.substr(2);
  }

  static formatSSN(str: string) {
    return str.substr(0, 3) + '-' + str.substr(3, 2) + '-' + str.substr(5);
  }

  static formatName(firstName: string, lastName: string): string {
    let name = '';

    if (!this.isNullOrEmptyString(lastName)) {
      name = lastName;
      if (!this.isNullOrEmptyString(firstName)) {
        name += ', ' + firstName;
      }
    } else if (!this.isNullOrEmptyString(firstName)) {
      name = firstName;
    }

    return name;
  }

  static formatEntityLegalName(firstName: string, middleName: string, lastName: string): string {
    let name = '';

    if (!this.isNullOrEmptyString(firstName)) {
      name = firstName;
    }

    if (!this.isNullOrEmptyString(middleName)) {
      name += ' ' + middleName.substring(0, 1) + '. ';
    } else {
      name += ' ';
    }

    if (!this.isNullOrEmptyString(lastName)) {
      name += lastName;
    }

    return name.trim();
  }

  static addSpacesBeforeCapitals(str: string) {
    return str[0] + str.substr(1).replace(/([A-Z])/g, ' $1');
  }

  static toWord(number: number) {
    if (number == null) {
      return '';
    }

    switch (number) {
      case 0:
        return 'zero';
      case 1:
        return 'one';
      case 2:
        return 'two';
      case 3:
        return 'three';
      case 4:
        return 'four';
      case 5:
        return 'five';
      case 6:
        return 'six';
      case 7:
        return 'seven';
      case 8:
        return 'eight';
      case 9:
        return 'nine';
      default:
        return number.toString();
    }
  }
}
